module.exports = __webpack_public_path__ + "static/img/logo_light.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/logo_light.png
// module id = yv0G
// module chunks = 0